import { computed } from 'vue';

import i18n from '@/i18n';

const t = i18n.global.t;

const addTranslatedField = (items, sourceField, targetField, prefix) => {
	return computed(() => items.map(item => {
		let result = { ...item };
		if (item[sourceField] != null) {
			result[targetField] = i18n.global.t(prefix + '.' + item[sourceField]);
		}
		if (item.children != null) {
			result.children = item.children.map(child => {
				let childResult = { ...child };
				if (child[sourceField] != null) {
					childResult[targetField] = i18n.global.t(prefix + '.' + child[sourceField]);
				}
				return childResult;
			});
		}
		return result;
	}));
}

export default {
	t,
	addTranslatedField,
}
